var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOcticonX16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50982 6.50967C6.75592 6.26389 7.08951 6.12583 7.43732 6.12583C7.78514 6.12583 8.11873 6.26389 8.36482 6.50967L13.9998 12.1447L19.6348 6.50967C19.7952 6.33691 19.9993 6.21061 20.2255 6.14408C20.4517 6.07756 20.6916 6.07327 20.92 6.13167C21.1484 6.19008 21.3569 6.30901 21.5234 6.47593C21.6899 6.64286 21.8083 6.85161 21.8661 7.08017C21.9246 7.30833 21.9205 7.54803 21.8543 7.77407C21.7881 8.00011 21.6622 8.20413 21.4898 8.36467L15.8548 13.9997L21.4898 19.6347C21.6626 19.7951 21.7889 19.9992 21.8554 20.2253C21.9219 20.4515 21.9262 20.6915 21.8678 20.9199C21.8094 21.1483 21.6905 21.3567 21.5236 21.5232C21.3566 21.6897 21.1479 21.8081 20.9193 21.8659C20.6912 21.9244 20.4515 21.9203 20.2254 21.8541C19.9994 21.7879 19.7954 21.662 19.6348 21.4897L13.9998 15.8547L8.36482 21.4897C8.11586 21.7214 7.78677 21.8476 7.44672 21.8417C7.10666 21.8358 6.78213 21.6983 6.54132 21.4582C6.30115 21.2174 6.16367 20.8928 6.1578 20.5528C6.15193 20.2127 6.27811 19.8836 6.50982 19.6347L12.1448 13.9997L6.50982 8.36467C6.26403 8.11858 6.12598 7.78499 6.12598 7.43717C6.12598 7.08936 6.26403 6.75577 6.50982 6.50967Z",
    fill: "#CD1919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcticonX16);
export default __webpack_public_path__ + "static/media/octicon_x-16.f2eeb2d24d82e07c8657ee606cc8c25f.svg";
export { ForwardRef as ReactComponent };